import { MenuProps } from 'antd'
import InnerNav from 'components/InnerNav/InnerNav'
import { t } from 'i18next'
import React, { Fragment, useEffect, useState } from 'react'
import Storage from './Components/Storage/Storage'
import Queue from './Components/Queue/Queue'
import Gateway from './Components/Gateway/Gateway'
import { InfrastructureNavSetting } from 'utils/enums'

interface  InfrastructureProps{
    currentAppKey: any;
    updateCurrentAppKey : any;
  }

const Infrastructure : React.FC<InfrastructureProps> = ({
    currentAppKey,
    updateCurrentAppKey
  }) => {
    const [appTabFilter, setAppTabFilter] = useState(InfrastructureNavSetting.STORAGE)
    const [selectedComponent, setSelectedComponent] =
      useState<JSX.Element | null>(null)
  
    const onTabClick: MenuProps["onClick"] = (e) => {
      setAppTabFilter(e.key)
    }
  
    useEffect(() => {
      switch (appTabFilter) {
        case InfrastructureNavSetting.STORAGE:
          setSelectedComponent(<Storage 
            currentAppKey={currentAppKey}
            updateCurrentAppKey={updateCurrentAppKey}
            />)
          break
        case InfrastructureNavSetting.QUEUE:
          setSelectedComponent(<Queue
            currentAppKey={currentAppKey}
            updateCurrentAppKey={updateCurrentAppKey}
           />)
          break
          case InfrastructureNavSetting.GATEWAY:
          setSelectedComponent(<Gateway
           />)
          break
       
           // Add cases for other tabs
      default:
        setSelectedComponent(<div></div>) // Default empty component
    }
  }, [appTabFilter])
  return (
    <Fragment>
        <div className="app-setting-container ">
        <div className="app-setting-nav">
          <InnerNav
            theme="light"
            onTabClick={onTabClick}
            selected={appTabFilter}
            menu={[
              {
                
                label: t("storageSettingLabel"),
                 key: InfrastructureNavSetting.STORAGE,
            
              },              
              {
                
                label: t("queueSettingLabel"),
                 key: InfrastructureNavSetting.QUEUE,
            
              }
              ,{
                
                label: t("gatewaySettingLabel"),
                 key: InfrastructureNavSetting.GATEWAY,
            
              },
         
            ]}
            />
          </div>
        </div>
        {selectedComponent}
      </Fragment>
    )
}

export default Infrastructure;